var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"news-text"},[_c('h2',[_vm._v("Newsletter")])]),_c('form',[_c('input',{attrs:{"type":"email","placeholder":"Enter your email"}}),_c('button',{attrs:{"type":"submit"}},[_vm._v("Subscribe")])])])
}]

export { render, staticRenderFns }